import React, { useState } from "react";
import {
    Box,
    Typography,
    CircularProgress,
    Alert,
} from "@mui/material";

import AssignmentIcon from "@mui/icons-material/Assignment";

export default function BeznalPayment({ data }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleInvoice = async () => {
        if (!data || loading) return;

        setLoading(true);
        setError("");

        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/advert/invoice`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(data),
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Ошибка формирования счёта: ${response.status}`
                );
            }

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.download = "invoice.pdf";

            document.body.appendChild(link);
            link.click();
            link.remove();

            setTimeout(() => URL.revokeObjectURL(url), 60000);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ mt: 3 }}>

            <Box
                component="button"
                type="button"
                disabled={loading}
                onClick={handleInvoice}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    width: "100%",
                    p: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                    backgroundColor: "transparent",
                    color: "primary.main",
                    textAlign: "left",
                    cursor: loading ? "wait" : "pointer",
                    transition: "all 0.2s ease-in-out",

                    "&:hover": {
                        borderColor: "primary.main",
                        backgroundColor: "action.hover",
                        boxShadow: "0 0 0 1px",
                        color: "primary.main",
                    },

                    "&:hover .invoice-label": {
                        textDecoration: "underline",
                    },

                    "&:focus-visible": {
                        outline: "2px solid",
                        outlineColor: "primary.main",
                        outlineOffset: 2,
                    },

                    "&:disabled": {
                        opacity: 0.6,
                        cursor: "wait",
                    },
                }}
            >
                {loading ? (
                    <CircularProgress size={64} />
                ) : (
                    <AssignmentIcon sx={{ fontSize: 72 }} />
                )}

                <Box>
                    <Typography
                        className="invoice-label"
                        variant="h6"
                        sx={{ fontWeight: 500 }}
                    >
                        Счёт для оплаты по безналичному расчёту
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            mt: 0.5,
                            color: "text.secondary",
                        }}
                    >
                        К оплате: {Number(data?.amount || 0).toFixed(2)} рублей
                    </Typography>
                </Box>
            </Box>


            {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                    {error}
                </Alert>
            )}
        </Box>
    );
}